import TestingPortal from './TestingPortal';

export default function LabReport() {
  const handleSave = async ({ header, tests }) => {
    const res = await fetch('/api/lab/reports/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ header, tests }),
    });
    if (!res.ok) throw new Error(`Server error ${res.status}`);
  };

  return <TestingPortal defaults={{ project: '…', issueTo: '…' }} onSave={handleSave} />;
}